<template>
  <div class="jumbotron">
    <loading :active.sync="loading"></loading>
    <div class="row">
      <div class="col">
        <h1>Checkout</h1>
      </div>
    </div>
    <div class="row special-margins">
      <div class="col-1 text-center three-side-box-border">
        <input type="checkbox" class="product-selection" checked>
      </div>
      <div class="col-11 box-border">
        <h5 class="d-inline">Yarlow Pro Services for $300</h5><p class="d-inline"> /month</p>
        <p>Makes your company searchable and a recommended pro on the Yarlow app.</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h5 class="no-margin-bottom">Recurring Payment Information</h5>
        <div id="dropin-container" class="no-margin-bottom"></div>
        <!--
        <p>Card number: 4111 1111 1111 1111</p>
        <p>Expiry: 09/20</p>
        <p>CVV: 400</p>
        -->
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <b-alert variant="danger" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">An error has occurred please try again later.</b-alert>
      </div>
    </div>
    <div class="row mb-3 mt-2">
      <div class="col-4">
        <h5>Receipt Email</h5>
      </div>
      <div class="col-8">
        <p>{{ email }}</p>
        <!--<input type="text" v-model="email" class="full-width">-->
      </div>
    </div>
    <div class="row mb-3 mt-2">
      <div class="col-4">
        <h5>Promotional Code</h5>
      </div>
      <div class="col-8">
        <input type="text" v-model="code" class="full-width">
      </div>
    </div>
    <div class="row mb-3 conditions-wrapper">
      <div class="col form-control">
        <input v-bind:class="{'is-invalid': agreedToTermsInvalid}" id="agree_terms" v-model="agreedToTerms" type="checkbox" required>
        <label for="agree_terms">I have read and understand the <router-link class="link" to="/terms" target="_blank">Conditions of Order</router-link><span class="red-text" v-if="!agreedToTerms">*</span></label>
      </div>
    </div>
    <div class="row needs-padding">
      <div class="col-6">
        <button class="btn btn-secondary" v-on:click="$router.go(-1)">Cancel</button>
      </div>
      <div class="col-6">
        <button v-on:click='checkout' class="btn btn-primary">Process Payment</button>
      </div>
    </div>
    <div class="alert-wrapper">
      <b-alert variant="warning"
               dismissible
               :show="mustAgreeToTermsMessage"
               @dismissed="mustAgreeToTermsMessage=false">
        Must agree to <router-link class="link" to="/terms" target="_blank">Conditions of Order</router-link> before purchasing Premium
      </b-alert>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      agreedToTerms: false,
      agreedToTermsInvalid: false,
      code: null,
      email: null,
      instance: null,
      loading: false,
      mustAgreeToTermsMessage: false,
      showDismissibleAlert: false
    }
  },
  computed: {
    ...mapGetters('serviceProvider', [
      'getCompanyId',
      'getEmail'
    ])
  },
  methods: {
    ...mapActions('serviceProvider', [
      'getBtToken',
      'getCurrentServiceProviderData',
      'premiumSignup'
    ]),
    async checkout () {
      this.loading = true
      this.instance.requestPaymentMethod(async (err, payload) => {
        if (err) {
          console.log(err)
          this.loading = false
          return
        }
        try {
          await this.premiumSignup({'payload': payload, 'code': this.code})
          // Retrieve details of plan
          await this.getCurrentServiceProviderData(this.getCompanyId)
          this.$router.push('/profile/serviceprovider/paymentinfo')
        } catch (error) {
          this.showDismissibleAlert = true
          console.log(error)
        }
        this.loading = false
      })
    },
    async showPayment () {
      try {
        var clientToken = await this.getBtToken()
        this.instance = await window.braintree.dropin.create({
          authorization: clientToken,
          container: '#dropin-container'
        })
      } catch (error) {
        console.log(error)
        this.showDismissibleAlert = true
      }
    }
  },
  async mounted () {
    this.email = this.getEmail
    this.loading = true
    await this.showPayment()
    this.loading = false
  }
}
</script>

<style scoped>
.btn {
  width: 100%;
}

.btn {
  margin-top: 0px !important;
}

.btn-secondary {
  margin: .5rem;
}

.box-border {
  border-style: solid;
  border-width: thin;
}

.conditions-wrapper {
  margin-left: 0;
  margin-right: 0;
}

.full-width {
  width: 100%;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.link {
  color: black;
  text-decoration: underline !important;
}

.link:hover {
  color: #748096;
}

.needs-padding {
  padding-top: 1rem;
}

.product-selection {
  margin-top: 30px;
}

.special-margins {
  margin-bottom: 2rem;
  margin-left: 0;
  margin-right: 0;
}

.three-side-box-border {
  border-style: solid none solid solid;
  border-width: thin;
}

.no-margin-bottom {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/serviceProviderProfile/ServiceProviderCheckout.vue